module.exports = __webpack_public_path__ + "static/media/icon-logs.6e1ac2d5.svg";